export default "//static.tradera.net/touchweb/static/output/images/app-download-mobile-2x.37a2f211.png";